module.exports = __webpack_public_path__ + "static/img/vivoV17.821d3cc7.png";